import React from 'react';
import _ from 'lodash';

import forwardRefWithTranslation from '@/common/forwardRefWithTranslation';

const { Menu } = Mobi2Go;
const { Order } = Mobi2Go;
const { UI } = Mobi2Go;

class MenuList extends React.Component {
    constructor() {
        super();

        this.state = {
            menu: Order.getMenu(),
            available_menus: Order.getAvailableMenus(),
        };

        Order.bind({
            updateAvailableMenus: available_menus =>
                this.setState({ available_menus }),
            updateMenu: menu => this.setState({ menu }),
        });

        UI.bind('showMenu', id => {
            let menu = null;
            if (_.isNumber(id)) {
                menu = Menu.getMenus().getById(id);
            } else {
                menu = Menu.getMenus().getByName(id);
            }

            if (!menu) {
                return;
            }

            const unavailable_products = Order.getUnavailableProductsForMenu(
                menu
            );
            if (unavailable_products.length) {
                this.warnAboutUnavailableItems(unavailable_products, menu);
                return;
            }

            this.switchMenu(menu);
        });
    }

    onSelectChange = e => {
        const menu_id = +e.target.value;
        UI.trigger('showMenu', menu_id);
    };

    onListItemClick = menu_id => {
        UI.trigger('showMenu', menu_id);
    };

    warnAboutUnavailableItems = (unavailable_products, menu) => {
        const { t } = this.props;
        let title = t('items_unavailable_title');
        let body = t('items_unavailable_body', { menu_name: menu.name });

        if (unavailable_products.length === 1) {
            const { menu_product } = unavailable_products[0];

            title = t('items_unavailable_one_title', {
                product_name: menu_product.name,
            });
            body = t('items_unavailable_one_body', {
                product_name: menu_product.name,
                menu_name: menu.name,
            });
        } else if (unavailable_products.length === 2) {
            body = t('items_unavailable_two_body', {
                product_name_1: unavailable_products[0].menu_product.name,
                product_name_2: unavailable_products[1].menu_product.name,
                menu_name: menu.name,
            });
        }

        UI.centeredAlert({
            title,
            body,
            primary_button: t('items_unavailable_primary_button'),
            onPrimaryButtonClick: () => {
                this.switchMenu(menu);
            },
            secondary_button: t('items_unavailable_secondary_button'),
        });
    };

    switchMenu = menu => {
        Order.setMenu(menu);
    };

    render() {
        if (this.state.available_menus.length < 2) {
            return null;
        }

        return (
            <div>
                <div
                    className="m2g-menu-select m2g-input-container m2g-form-element-group m2g-hidden"
                    data-icon-after="select"
                >
                    <select
                        value={this.state.menu.id}
                        onChange={this.onSelectChange}
                        className="m2g-menu-select-element m2g-select m2g-form-element--full-width"
                    >
                        {this.state.available_menus.map(available_menu => (
                            <option
                                onSelect={this.onChange}
                                key={available_menu.id}
                                value={available_menu.id}
                            >
                                {available_menu.name}
                            </option>
                        ))}
                    </select>
                </div>

                <div>
                    <div className="m2g-menu-list m2g-nav-list m2g-nav-list--horizontal">
                        {this.state.available_menus.map(menu => (
                            <a
                                data-menu={menu.id}
                                onClick={() => this.onListItemClick(menu.id)}
                                key={menu.id}
                                data-menu-name={menu.backend_name}
                                data-tags={menu.tags.join(' ')}
                                className={`m2g-menu-list-item m2g-nav-list-item m2g-nav-list-item--hoverable ${
                                    this.state.menu.id === menu.id
                                        ? 'm2g-nav-list-item--active'
                                        : ''
                                }`}
                            >
                                {menu.name}
                            </a>
                        ))}
                    </div>
                </div>
            </div>
        );
    }
}

export default forwardRefWithTranslation('menu.list')(MenuList);
